<template>
  <!--  <div class="about">
    <h1>Community</h1>
    <router-link to="/community/faq">FAQ</router-link>
    <router-link to="/community/feed">Feed</router-link>

  </div>-->
  <router-view />
</template>

<script>
  export default{
  name: 'CommunityView'
  };
</script>
